<template>
<ScreenLayout>
    <div slot="left" class="white-background" style="position:relative;display:flex;flex-direction:column;height:100%">
       
    </div>

    <!-- Form -->

    <div v-if="item" class="white responsive-boundary" style="position:relative;">

        <FormBlock ref="block" :schema="scenarioSchema" v-model="item" :context="formContext" @change="formChanged" /> 

    </div>

    <div slot="right" class="pa-4 white">

        <!-- <ExpansionPanel /> -->

        {{formContext.focusedField}}
        <Activities :activities="someComments" style="max-height:300px;" />

        <div v-for="request in requests" :key="request._id">
            {{request.name}}
            <div class="light-text">
                {{policyAsText(request.policy)}}
            </div>

        </div>

    </div>

</ScreenLayout>
</template>

<script>
import ScreenLayout from '@/screens/ScreenLayout'
import Db from '@/data/Db'
import Db1 from '@/data/Db1'
import ConfirmIcon from '@/ui-elements/ConfirmIcon'
import ListList from '@/forms/lists/ListList'
import RouterHelpers from '@/helpers/RouterHelpers'
import FormControl from '../forms/FormControl'
import Activities from '../forms/activity/Activities'

import ChecklistSchemas from './ChecklistSchemas'
import ChecklistRules from './ChecklistRules'

import ExpansionPanel from '../ui-elements/ExpansionPanel'

export default {
    name: 'Checklist',

    components: {
        ScreenLayout, ConfirmIcon, ListList, FormControl, Activities, ExpansionPanel,
    },
    data() {
        return {
            requests: [],
            policiesDoc: null,
            // selectedIndex: null,
            item: {},
            proofsDoc: null,
            testItem: {
                first_name: 'Matty',
                last_name: 'Ireland',
            },

            formContext: {hello: 'World'},

            someComments: [
                {'description': 'This is my little comment. Please disregard for now until I expand on it'},
                {'description': 'Sure, I will ignore, but I cannot wait until this is working properly!!'},
            ],
            scenarioSchema: null,

      
            
        }
    },
    computed:{

        items() {
            if(!this.proofsDoc)
                return []
            if(!this.proofsDoc.list)
                this.proofsDoc.list = []
            return this.proofsDoc.list
        },

        lists() { 
            return [
                {
                    name: 'Proofs',
                    schema: this.proofSchema,
                    path: 'apps/dc/lists/proofs',
                }
            ]
        },
        currentList() {
            return this.lists[1]
        },

        allPolicies() {
            return this.getAllPolicies(this.policiesDoc)
        }, 


    },
    methods: {
        getPolicyForField(fieldName) {
            if(!fieldName)
                return null
            return this.allPolicies.find(o => o.checklistField == fieldName)
        },
        getAllPolicies(doc) {
            if(!doc)
                return []

            const policies = []
            doc.categories.forEach(cat => {
                if(cat.policies) {
                    cat.policies.forEach(pol => {
                        policies.push(pol)
                    })
                }
            }) 
            return policies  
        },


        /* Structure of changes

        changes: {
            type: "Row Added, Row Changed, Row Removed, Field Changed",
            rowName: 'xxxx',
            row: {...}
        }
        
        */

        formChanged(changes) {
            
            ChecklistRules.addPolicy(changes)


            if(
                changes.type == 'Row Added' || changes.type == 'Row Changed' ||
                (changes.type == 'Field Changed' && changes.value)
            ) {
                console.log('Should add something here ++++')
                this.injectRequest(changes)
            } else {
                this.deleteRequest(changes)
                console.log('Should remove something here ----')
            }
            console.log(changes)
            
        },

        injectRequest(changes) {
            const policy = this.getPolicyByName(changes.policy)
            
            const request = this.getNewOrExistingRequest(changes)
            request.name = changes.rowName || policy.name
            request.policy = policy
            
        },

        getExistingRequest(changes) {
           let request = this.requests.find(
                o => (o.rowId == changes.rowId || !changes.rowId) &&
                (o.field == changes.field || !changes.field)
            )
            return request
        },

        makeNewRequest(changes) {
            
            const request = {}
            request._id = this.changesToRequestId(changes)
            const obj = this.splitRequestId(request._id)
            Object.assign(request, obj)

            request.name = ''
            this.requests.push(request)
            return request
        },

        changesToRequestId(changes) {
            return (changes.collection || 'global') + '/' +
                (changes.rowId || 'main') + '/' +
                (changes.field || 'none')
        },

        splitRequestId(requestId) {
            const arr = requestId.split('/')
            const obj = {
                collection: arr[0],
                rowId: arr[1],
                field: arr[2],
            }
        },

        getNewOrExistingRequest(changes) {
            return this.getExistingRequest(changes) || this.makeNewRequest(changes)
        },

        deleteRequest(changes) {
            const id = this.changesToRequestId(changes)
            const idx = this.requests.findIndex(o => o._id == id)
            if(!idx) {
                console.log('Cannot delete from list. Changes:', changes)
            }
            this.requests.splice(idx, 1)
        },        

        getPolicyByName(name) {
            
            const policy = this.allPolicies.find(o => o.name == name)
            if(!policy)
                console.error('getPolicyByName fails to find policy for:', name)
            return policy
        },

        policyAsText(policy) {
            if(!policy)
                return ''
            return policy.default.options[0].requirements.map(o => o.description).join(' and ')
        },

        removeRequest(id) {
            const idx = this.requests.findIndex(o => o._id == id)
            if(idx > -1)
                this.requests.splice(idx, 1)
        },


        select(item) {
            this.item = item || this.items[0]
            RouterHelpers.setQueryParameter(this, 'i', item._id)
        },

        add() {
            const newItem = {
                _id: Db1.newId(),
                title: 'New Item'
            }
            this.items.unshift(newItem)
            this.select(newItem)
            this.$refs.itemForm.focusFirst()
        },
        save() {
            //Db1.saveDocument(this.proofsDoc)
        },

        deleteCurrent() {
            const idx = this.items.findIndex(p => p == this.item)
            this.items.splice(idx, 1)
            this.select()
            this.save()
        }
    },

    created() {   
        this.scenarioSchema = ChecklistSchemas.getScenarioSchema()

        Db1.fetchDocumentByCode('apps/dc/lists', 'policies').then(doc => {
            this.policiesDoc = doc

            //load default values into requirements...
            // this.allPolicies.forEach(policy => {
            //     this.setStipulation(policy)
            // })
        })
    },

    beforeDestroy() {
        this.save()
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



    .responsive-boundary {
        padding:10px
    }
    @media (min-width: 500px) {
        .responsive-boundary {
                margin: 30px;
                padding: 30px;
                box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px !important;
        }
    }    
</style>


// WEBPACK FOOTER //
// Checklist.vue?7e629c70